/*
* @Author: abhishek714
* @Date:   2025-05-29 16:22:00
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-09-17 10:33:46
*/
import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class UserServices {
	async login(data){
		const url = `${REP_API_URL}login`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		});
	}

	async getCustomerdata(data,permalink){
        const url = `${REP_API_URL}get-customer-data/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }
}
export default UserServices;